/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState } from 'react';
import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';

const moduleImporter = (retries = 3) => import('./DynamicAssistant')
  .catch((err) => {
    if (retries > 0) {
      return moduleImporter(retries - 1);
    }
    throw err;
  });
const Server = () => (<></>);

export const DynamicMAA = (props) => {
  const moduleRef = useRef(null);
  const [_, forceRender] = useState();

  useEffect(() => {
    moduleImporter()
      .then((module) => {
        moduleRef.current = module.DynamicAssistant;
        if (!moduleRef.current) {
          throw new Error('Error importing Dynamic Assistant.');
        }
        forceRender(new Date().getTime());
      });
  }, []);

  if (typeof window === 'undefined' || !moduleRef.current) return Server();

  return (
    <moduleRef.current {...props} />
  );
};